/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_Role_2Inputs */

const en_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software engineer`)
};

const de_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler`)
};

const fr_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur logiciel`)
};

const es_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeniero de software`)
};

const it_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingegnere del software`)
};

const nl_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareontwikkelaar`)
};

const pl_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inżynier oprogramowania`)
};

const fi_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohjelmistoinsinööri`)
};

const da_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareingeniør`)
};

const sv_landing_application_overview_role_2 = /** @type {(inputs: Landing_Application_Overview_Role_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mjukvaruingenjör`)
};

/**
* | output |
* | --- |
* | "Software engineer" |
*
* @param {Landing_Application_Overview_Role_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_role_2 = /** @type {((inputs?: Landing_Application_Overview_Role_2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_Role_2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_role_2(inputs)
	if (locale === "fr") return fr_landing_application_overview_role_2(inputs)
	if (locale === "es") return es_landing_application_overview_role_2(inputs)
	if (locale === "it") return it_landing_application_overview_role_2(inputs)
	if (locale === "nl") return nl_landing_application_overview_role_2(inputs)
	if (locale === "pl") return pl_landing_application_overview_role_2(inputs)
	if (locale === "fi") return fi_landing_application_overview_role_2(inputs)
	if (locale === "da") return da_landing_application_overview_role_2(inputs)
	if (locale === "sv") return sv_landing_application_overview_role_2(inputs)
	return en_landing_application_overview_role_2(inputs)
});